import { QueryState } from '@/common/enum';
import { Nullable } from 'interfaces/Nullable.ts';
import { IStationOneAvailablePosts } from 'interfaces/admin.interface.ts';

export type StationStateTypes = {
  queryState: QueryState;
  activeGroupId: Nullable<number>;
  selectedPostSetting: Nullable<IStationOneAvailablePosts>;
  error: Nullable<string>;
};

export const StationInitialState: StationStateTypes = {
  queryState: QueryState.UNDEFINED,
  activeGroupId: null,
  selectedPostSetting: null,
  error: null,
};
